import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthGuard } from '@reg/shared/auth';
import { AuthService } from '@reg/shared/service';
import { AuthUser } from '@reg/shared/model';

/**
 * This guard is meant to be used for routes that should not be loadable
 * without authenticating with FloSports.  If they are not authenticated with ROLE_ADMIN, then
 * it will redirect them to the login funnel where they will be redirected back
 * here once they authenticate.
 */
@Injectable()
export class AdminAuthGuard extends AuthGuard {
    constructor(
        authService: AuthService,
        router: Router,
    ) {
        super(authService, router);
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (super.canActivate(route, state)) {
            if (this.authService.user &&
                this.authService.user.isAdmin()) {
                return true;
            }
            this.router.navigate(['error', 'access-denied']);
        }

        return false;
    }
}
